import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Shield,
  Zap,
  RefreshCw,
  DollarSign,
  Wrench,
  Bug,
  BarChart,
  Save,
  FileText,
  CheckCircle,
  XCircle,
  Activity,
  ArrowRight,
} from "lucide-react";
import "./Maintenance.css";
import { subscribeToNewsletter } from "./newsletterService";

export default function MaintenanceServices() {
  const [isScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const startProject = () => {
    window.location.href = "/#contact";
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const email = form.newsletterEmail?.value || "";
    const result = subscribeToNewsletter(email);
    window.alert(result.message);
    if (result.ok) {
      form.reset();
    }
  };

  const maintenanceGallery = [
    {
      src: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80",
      title: "Proactive Monitoring",
      tag: "Reliability",
    },
    {
      src: "https://images.unsplash.com/photo-1484417894907-623942c8ee29?auto=format&fit=crop&w=1200&q=80",
      title: "Performance Optimization",
      tag: "Speed",
    },
    {
      src: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=1200&q=80",
      title: "Continuous Improvements",
      tag: "Support",
    },
  ];

  return (
    <div className="maintenance-page">
      {/* Navigation */}
      <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
              <div className="container navbar-container">
                <a href="/" className="navbar-brand">
                  <img src="/TechXM-logo.png" alt="TECHXM logo" className="brand-logo-mark" width="30" height="30" />
                </a>
      
                <div className={`navbar-menu ${mobileMenuOpen ? "active" : ""}`}>
                  <div className="services-dropdown">
                    <div className="navbar-link active-link">Services</div>
                    <div className="dropdown-menu">
                      <Link to="/web-development" className="dropdown-item">
                        <i className="fas fa-laptop-code"></i>
                        Web Development Services
                      </Link>
                      <Link to="/mobile-app" className="dropdown-item">
                        <i className="fas fa-mobile-alt"></i>
                        Mobile App Development
                      </Link>
                      <Link to="/custom-software" className="dropdown-item">
                        <i className="fas fa-cogs"></i>
                        Custom Software Development
                      </Link>
                      <Link to="/api-backend" className="dropdown-item">
                        <i className="fas fa-plug"></i>
                        API & Backend Services
                      </Link>
                      <Link to="/maintenance" className="dropdown-item active-link">
                        <i className="fas fa-tools"></i>
                        Website & App Maintenance
                      </Link>
                      <Link to="/ai-services" className="dropdown-item">
                        <i className="fas fa-robot"></i>
                        AI & Machine Learning Services
                      </Link>
                    </div>
                  </div>
                  {/* <a href="/#work" className="navbar-link">Work</a> */}
                  <a href="/#about" className="navbar-link">
                    About
                  </a>
{/*
                  <a href="/#testimonials" className="navbar-link">
                    Testimonials
                  </a>
*/}
                  <a href="/#faq" className="navbar-link">
                    FAQ
                  </a>
                  <a href="/#contact" className="navbar-link">
                    Contact
                  </a>
                  <Link to="/track-project" className="navbar-link">
                    Track Project
                  </Link>
                  <button className="btn btn-primary nav-consult-btn" onClick={startProject}>
                    Request Consultation
                  </button>
                </div>
      
                <button
                  className="navbar-toggle"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                  <i className={`fas ${mobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
                </button>
              </div>
            </nav>

      {/* Hero Section */}
      <section className="maintenance-hero">
        <div className="maintenance-container">
          <div className="maintenance-breadcrumb">
            <Link to="/" className="breadcrumb-link">
              Home
            </Link>{" "}
            /{" "}
            <Link to="/#services" className="breadcrumb-link">
              Services
            </Link>{" "}
            /{" "}
            <span className="breadcrumb-current">
              Website and App Maintenance
            </span>
          </div>
          <h1 className="maintenance-hero-title">
            Website and App Maintenance
          </h1>
          <p className="maintenance-hero-description">
            Keep your digital assets running smoothly with our comprehensive
            maintenance and support services for Johannesburg and South African
            teams. We ensure your website and applications stay secure, updated,
            and performing at their best.
          </p>
        </div>
      </section>

      {/* Overview Section */}
      <section className="maintenance-overview">
        <div className="maintenance-container">
          <div className="maintenance-grid-2col">
            <div className="maintenance-content">
              <h2 className="maintenance-section-title">
                Ongoing Support for Peak Performance
              </h2>
              <p className="maintenance-text-content">
                Launching your website or app is just the beginning. Regular
                maintenance is essential to ensure security, performance, and
                reliability. Our maintenance services keep your digital assets
                running smoothly, allowing you to focus on your business while
                serving customers across Johannesburg.
              </p>
              <p className="maintenance-text-content">
                From security updates and bug fixes to performance optimization
                and feature enhancements, we provide comprehensive support that
                keeps your website and applications secure, fast, and
                up-to-date.
              </p>
              <div className="maintenance-benefits-box">
                <h3 className="maintenance-benefits-title">
                  Why Structured Maintenance?
                </h3>
                <div className="maintenance-benefits-list">
                  <div className="maintenance-benefit-item">
                    <CheckCircle className="checkmark-icon" />
                    <span>Regular security updates and patches</span>
                  </div>
                  <div className="maintenance-benefit-item">
                    <CheckCircle className="checkmark-icon" />
                    <span>Performance monitoring and optimization</span>
                  </div>
                  <div className="maintenance-benefit-item">
                    <CheckCircle className="checkmark-icon" />
                    <span>Bug fixes and issue resolution</span>
                  </div>
                  <div className="maintenance-benefit-item">
                    <CheckCircle className="checkmark-icon" />
                    <span>Content updates and changes</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="maintenance-image-container">
              <img
                src="https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=1400&q=80"
                alt="Maintenance Dashboard"
                className="maintenance-main-image"
              />
              <div className="maintenance-stat-card">
                <div className="maintenance-stat-icon">
                  <Shield className="stat-icon" />
                </div>
                <div className="maintenance-stat-content">
                  <div className="maintenance-stat-number">24/7</div>
                  <div className="maintenance-stat-label">Monitoring</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Visual Showcase */}
      <section className="maintenance-showcase-section">
        <div className="maintenance-container">
          <h2 className="maintenance-section-title-center">
            Maintenance That Keeps You Moving
          </h2>
          <p className="maintenance-section-subtitle">
            A modern support workflow focused on uptime, speed, and long-term
            product stability.
          </p>
          <div className="maintenance-showcase-grid">
            {maintenanceGallery.map((item, idx) => (
              <article key={idx} className="maintenance-showcase-card">
                <img
                  src={item.src}
                  alt={item.title}
                  className="maintenance-showcase-image"
                />
                <div className="maintenance-showcase-overlay">
                  <span className="maintenance-showcase-tag">{item.tag}</span>
                  <h3 className="maintenance-showcase-title">{item.title}</h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Key Benefits Section */}
      <section className="maintenance-benefits-section">
        <div className="maintenance-container">
          <h2 className="maintenance-section-title-center">
            The Maintenance Advantage
          </h2>
          <div className="maintenance-benefits-grid">
            <div className="maintenance-benefit-card">
              <div className="maintenance-benefit-icon">
                <Shield className="benefit-icon" />
              </div>
              <h3 className="maintenance-benefit-card-title">Security First</h3>
              <p className="maintenance-benefit-card-text">
                Regular security patches, vulnerability scanning, and proactive
                threat prevention.
              </p>
            </div>
            <div className="maintenance-benefit-card">
              <div className="maintenance-benefit-icon">
                <Zap className="benefit-icon" />
              </div>
              <h3 className="maintenance-benefit-card-title">
                Peak Performance
              </h3>
              <p className="maintenance-benefit-card-text">
                Continuous optimization ensures fast loading times and smooth
                user experience.
              </p>
            </div>
            <div className="maintenance-benefit-card">
              <div className="maintenance-benefit-icon">
                <RefreshCw className="benefit-icon" />
              </div>
              <h3 className="maintenance-benefit-card-title">Always Updated</h3>
              <p className="maintenance-benefit-card-text">
                Keep software, plugins, and dependencies up-to-date with latest
                features.
              </p>
            </div>
            <div className="maintenance-benefit-card">
              <div className="maintenance-benefit-icon">
                <DollarSign className="benefit-icon" />
              </div>
              <h3 className="maintenance-benefit-card-title">Cost Effective</h3>
              <p className="maintenance-benefit-card-text">
                Prevent costly emergencies with regular maintenance and
                proactive monitoring.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="maintenance-services-section">
        <div className="maintenance-container">
          <h2 className="maintenance-section-title-center">
            Our Maintenance Services
          </h2>
          <p className="maintenance-section-subtitle">
            Enterprise support services designed to protect uptime and
            operational continuity
          </p>
          <div className="maintenance-services-grid">
            <div className="maintenance-service-card">
              <div className="maintenance-service-icon">
                <Wrench className="service-icon" />
              </div>
              <h3 className="maintenance-service-title">Technical Updates</h3>
              <p className="maintenance-service-description">
                Software updates, plugin management, security patches, and
                compatibility fixes.
              </p>
            </div>
            <div className="maintenance-service-card">
              <div className="maintenance-service-icon">
                <Bug className="service-icon" />
              </div>
              <h3 className="maintenance-service-title">Bug Fixes</h3>
              <p className="maintenance-service-description">
                Quick resolution of issues, errors, and unexpected behavior
                across all platforms.
              </p>
            </div>
            <div className="maintenance-service-card">
              <div className="maintenance-service-icon">
                <Activity className="service-icon" />
              </div>
              <h3 className="maintenance-service-title">
                Performance Monitoring
              </h3>
              <p className="maintenance-service-description">
                24/7 uptime monitoring, speed optimization, and server health
                tracking.
              </p>
            </div>
            <div className="maintenance-service-card">
              <div className="maintenance-service-icon">
                <Save className="service-icon" />
              </div>
              <h3 className="maintenance-service-title">Backup Management</h3>
              <p className="maintenance-service-description">
                Automated backups, disaster recovery planning, and data
                restoration services.
              </p>
            </div>
            <div className="maintenance-service-card">
              <div className="maintenance-service-icon">
                <FileText className="service-icon" />
              </div>
              <h3 className="maintenance-service-title">Content Updates</h3>
              <p className="maintenance-service-description">
                Text changes, image updates, new pages, and content management
                support.
              </p>
            </div>
            <div className="maintenance-service-card">
              <div className="maintenance-service-icon">
                <BarChart className="service-icon" />
              </div>
              <h3 className="maintenance-service-title">
                Analytics & Reporting
              </h3>
              <p className="maintenance-service-description">
                Monthly reports on performance, security, and user analytics
                insights.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Maintenance Types Section */}
      <section className="maintenance-types-section">
        <div className="maintenance-container">
          <div className="maintenance-types-grid">
            <div className="maintenance-types-content">
              <h2 className="maintenance-section-title">
                Types of Maintenance
              </h2>
              <p className="maintenance-text-content">
                We provide different levels of maintenance support based on your
                operational requirements
              </p>
              <div className="maintenance-types-list">
                <div className="maintenance-type-item">
                  <div className="maintenance-type-number">01</div>
                  <div className="maintenance-type-content">
                    <h3 className="maintenance-type-title">
                      Preventive Maintenance
                    </h3>
                    <p className="maintenance-type-text">
                      Regular updates and monitoring to prevent issues before
                      they occur.
                    </p>
                  </div>
                </div>
                <div className="maintenance-type-item">
                  <div className="maintenance-type-number">02</div>
                  <div className="maintenance-type-content">
                    <h3 className="maintenance-type-title">
                      Corrective Maintenance
                    </h3>
                    <p className="maintenance-type-text">
                      Quick fixes for bugs, errors, and issues as they arise.
                    </p>
                  </div>
                </div>
                <div className="maintenance-type-item">
                  <div className="maintenance-type-number">03</div>
                  <div className="maintenance-type-content">
                    <h3 className="maintenance-type-title">
                      Adaptive Maintenance
                    </h3>
                    <p className="maintenance-type-text">
                      Updates to keep your software compatible with new
                      technologies.
                    </p>
                  </div>
                </div>
                <div className="maintenance-type-item">
                  <div className="maintenance-type-number">04</div>
                  <div className="maintenance-type-content">
                    <h3 className="maintenance-type-title">
                      Perfective Maintenance
                    </h3>
                    <p className="maintenance-type-text">
                      Enhancements and optimizations to improve performance and
                      features.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="maintenance-image-container">
              <img
                src="https://images.unsplash.com/photo-1518773553398-650c184e0bb3?auto=format&fit=crop&w=1400&q=80"
                alt="Maintenance Types"
                className="maintenance-main-image"
              />
              <div className="maintenance-stat-card">
                <div className="maintenance-stat-icon">
                  <Zap className="stat-icon" />
                </div>
                <div className="maintenance-stat-content">
                  <div className="maintenance-stat-number">&lt; 2 hrs</div>
                  <div className="maintenance-stat-label">Response Time</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="maintenance-pricing-section">
        <div className="maintenance-container">
          <h2 className="maintenance-section-title-center">
            Maintenance Packages
          </h2>
          <p className="maintenance-section-subtitle">
            Monthly support plans aligned to platform complexity and business
            requirements
          </p>
          <div className="maintenance-pricing-grid">
            {/* Basic Package */}
            <div className="maintenance-pricing-card">
              <h3 className="maintenance-package-name">Basic</h3>
              <div className="maintenance-package-price">
                R499<span className="maintenance-price-period">/month</span>
              </div>
              <p className="maintenance-package-ideal">
                Small websites & blogs
              </p>
              <ul className="maintenance-package-features">
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Monthly security updates</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Weekly backups</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Basic performance monitoring</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>2 hours of support/month</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Email support</span>
                </li>
                <li className="maintenance-feature-excluded">
                  <XCircle className="feature-icon" />
                  <span>Priority support</span>
                </li>
                <li className="maintenance-feature-excluded">
                  <XCircle className="feature-icon" />
                  <span>24/7 monitoring</span>
                </li>
                <li className="maintenance-feature-excluded">
                  <XCircle className="feature-icon" />
                  <span>Dedicated account manager</span>
                </li>
              </ul>
              <button className="maintenance-package-button" onClick={startProject}>
                Discuss Requirements
              </button>
            </div>

            {/* Professional Package */}
            <div className="maintenance-pricing-card maintenance-pricing-card-popular">
              <div className="maintenance-popular-badge">MOST POPULAR</div>
              <h3 className="maintenance-package-name">Professional</h3>
              <div className="maintenance-package-price">
                R2,999<span className="maintenance-price-period">/month</span>
              </div>
              <p className="maintenance-package-ideal">
                Business websites & apps
              </p>
              <ul className="maintenance-package-features">
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Weekly security updates</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Daily backups</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Advanced monitoring</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>10 hours of support/month</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Priority email & phone</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Monthly reports</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Performance optimization</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Content updates included</span>
                </li>
              </ul>
              <button className="maintenance-package-button" onClick={startProject}>
                Discuss Requirements
              </button>
            </div>

            {/* Enterprise Package */}
            <div className="maintenance-pricing-card">
              <h3 className="maintenance-package-name">Enterprise</h3>
              <div className="maintenance-package-price">
                R6,999<span className="maintenance-price-period">/month</span>
              </div>
              <p className="maintenance-package-ideal">
                Large platforms & systems
              </p>
              <ul className="maintenance-package-features">
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Real-time security monitoring</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Continuous backups</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>24/7 monitoring & alerts</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Unlimited support hours</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Dedicated account manager</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Custom SLA agreements</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Infrastructure management</span>
                </li>
                <li className="maintenance-feature-included">
                  <CheckCircle className="feature-icon" />
                  <span>Priority emergency response</span>
                </li>
              </ul>
              <button className="maintenance-package-button" onClick={startProject}>
                Discuss Requirements
              </button>
            </div>
          </div>
          <p className="maintenance-pricing-note">
            All packages include monthly performance reports and security audits
          </p>
        </div>
      </section>

      {/* Process Section */}
      <section className="maintenance-process-section">
        <div className="maintenance-container">
          <h2 className="maintenance-section-title-center">
            Our Maintenance Process
          </h2>
          <p className="maintenance-section-subtitle">
            How we maintain security, performance, and operational stability
          </p>
          <div className="maintenance-process-grid">
            <div className="maintenance-process-step">
              <div className="maintenance-step-number">1</div>
              <h3 className="maintenance-step-title">Initial Assessment</h3>
              <p className="maintenance-step-description">
                Comprehensive audit of your website or app to identify immediate
                needs and potential issues.
              </p>
            </div>
            <div className="maintenance-process-step">
              <div className="maintenance-step-number">2</div>
              <h3 className="maintenance-step-title">Setup & Monitoring</h3>
              <p className="maintenance-step-description">
                Configure monitoring tools, backup systems, and establish
                maintenance schedules.
              </p>
            </div>
            <div className="maintenance-process-step">
              <div className="maintenance-step-number">3</div>
              <h3 className="maintenance-step-title">Regular Updates</h3>
              <p className="maintenance-step-description">
                Scheduled updates, security patches, and performance
                optimizations on a regular basis.
              </p>
            </div>
            <div className="maintenance-process-step">
              <div className="maintenance-step-number">4</div>
              <h3 className="maintenance-step-title">Issue Resolution</h3>
              <p className="maintenance-step-description">
                Quick response to bugs, errors, and security threats with
                efficient problem-solving.
              </p>
            </div>
            <div className="maintenance-process-step">
              <div className="maintenance-step-number">5</div>
              <h3 className="maintenance-step-title">Reporting</h3>
              <p className="maintenance-step-description">
                Monthly reports detailing all maintenance activities,
                performance metrics, and recommendations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="maintenance-cta-section">
        <div className="maintenance-container">
          <div className="maintenance-cta-content">
            <h2 className="maintenance-cta-title">
              Plan Your Ongoing Support Strategy
            </h2>
            <p className="maintenance-cta-description">
              Align your maintenance model with business priorities and keep
              your digital systems dependable.
            </p>
          <div className="maintenance-cta-buttons">
              <button className="maintenance-cta-button maintenance-cta-button-primary" onClick={startProject}>
                Request Consultation <ArrowRight className="cta-button-icon" />
              </button>
          </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-decoration"></div>
        <div className="footer-decoration"></div>

        <div className="container">
          <div className="footer-grid">
            <div>
              <div className="footer-brand">
                <img src="/TechXM-logo.png" alt="TECHXM logo" className="brand-logo-mark" width="30" height="30" />
              </div>
              <p className="footer-about">
                We design, build, and support secure digital systems for
                organizations that require reliability, scalability, and strong
                delivery governance.
              </p>
              <div className="footer-social">
                <a
                  href="https://www.linkedin.com/company/techxm/"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
                <a
                  href="https://www.instagram.com/techxm_za/"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="https://www.facebook.com/"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-links">
                <li>
                  <a href="/web-development">
                    <i className="fas fa-chevron-right"></i>
                    Web Development
                  </a>
                </li>
                <li>
                  <a href="/mobile-app">
                    <i className="fas fa-chevron-right"></i>
                    Mobile Apps
                  </a>
                </li>
                <li>
                  <a href="/custom-software">
                    <i className="fas fa-chevron-right"></i>
                    Custom Software
                  </a>
                </li>
                <li>
                  <a href="/api-backend">
                    <i className="fas fa-chevron-right"></i>
                    API & Backend
                  </a>
                </li>
                <li>
                  <a href="/maintenance">
                    <i className="fas fa-chevron-right"></i>
                    Maintenance
                  </a>
                </li>
                <li>
                  <a href="/ai-services">
                    <i className="fas fa-chevron-right"></i>
                    AI & Machine Learning
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-links">
                <li>
                  <a href="/#about">
                    <i className="fas fa-chevron-right"></i>
                    About
                  </a>
                </li>
                <li>
                  <a href="/#faq">
                    <i className="fas fa-chevron-right"></i>
                    FAQ
                  </a>
                </li>
                <li>
                  <a href="/track-project">
                    <i className="fas fa-chevron-right"></i>
                    Track Project
                  </a>
                </li>
                <li>
{/*
                  <a href="/#testimonials">
                    <i className="fas fa-chevron-right"></i>
                    Testimonials
                  </a>
*/}
                </li>
                <li>
                  <a href="/#contact">
                    <i className="fas fa-chevron-right"></i>
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="footer-heading">Contact Info</h4>
              <div className="footer-contact">
                <div className="contact-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <span> Ohemimuri, Walkerville</span>
                </div>
                <div className="contact-item">
                  <i className="fas fa-phone"></i>
                  <a href="tel:0765536048">076 553 6048</a>
                  <span> / </span>
                  <a href="tel:0742686212">074 268 6212</a>
                </div>
                <div className="contact-item">
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:info@techxm.co.za">info@techxm.co.za</a>
                </div>
                <div className="contact-item">
                  <i className="fas fa-clock"></i>
                  <span>Mon - Fri: 9:00 - 18:00</span>
                </div>
              </div>

              <div className="footer-newsletter">
                <p className="newsletter-text">Subscribe to our newsletter</p>
                <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                  <input
                    type="email"
                    name="newsletterEmail"
                    className="newsletter-input"
                    placeholder="Your email address"
                    required
                  />
                  <button type="submit" className="newsletter-btn">
                    <i className="fas fa-paper-plane"></i>
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>
              &copy; 2025 TECHXM. All rights reserved. Enterprise Digital
              Solutions.
            </p>
            <div className="footer-legal">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-service">Terms of Service</a>
              <a href="/cookie-policy">Cookie Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}








